import React, {createContext, useState, useEffect, useContext, useReducer} from 'react'
import {initGTM, sendToGTM} from './utils/GoogleTagManager'
import {useGlobalStore} from '../../store/hooks/useStore'
import {initOneTrust, setDefaultConsent} from './utils/OneTrust'

/**
 * The initial state
 */
export const initialState = {
  dataLayer: undefined,
  dataLayerName: 'dataLayer',
  environment: undefined,
  nonce: undefined,
  id: '',
  injectScript: true,
  serverName: undefined
}
/**
 * The context
 */
export const GTMContext = createContext(initialState)
export const GTMContextDispatch = createContext(undefined)
let queuedData = []
function dataReducer(state, data) {
  if (window[state.dataLayerName]) {
    sendToGTM({data, dataLayerName: state?.dataLayerName})
    if (queuedData.length > 0) {
      queuedData.forEach(data => {
        sendToGTM({data, dataLayerName: state?.dataLayerName})
      })
      queuedData = []
    }
  } else {
    queuedData = [...queuedData, data]
  }
  return state
}
export const OneTrustCheckCompletedContext = createContext(); 
/**
 * The Google Tag Manager Provider
 */
function GTMProvider({state, children}) {
  const [store, dispatch] = useReducer(dataReducer, {...initialState, ...state})

  const {getCustomSitePreferenceById, isCustomSitePreferenceSet, customSitePreferences} =
  useGlobalStore()

  const [oneTrustEnabled, setOneTrustEnabled] = useState(false)
  const [oneTrustId, setOneTrustId] = useState('')
  const [oneTrustCheckCompleted, setOneTrustCheckCompleted] = useState(false)

  useEffect(() => {
    (async function () {
      if (!isCustomSitePreferenceSet('oneTrustEnabled')) {
        await getCustomSitePreferenceById('oneTrustEnabled')
      }
      if (!isCustomSitePreferenceSet('oneTrustId')) {
        await getCustomSitePreferenceById('oneTrustId')
      }
      setOneTrustEnabled(customSitePreferences['oneTrustEnabled'] === true)
      setOneTrustId(customSitePreferences['oneTrustId'])
      setOneTrustCheckCompleted(true)
    })()
  })

  useEffect(() => {
    if (!oneTrustCheckCompleted || !state || state.injectScript == false) return
    const mergedState = {...store, ...state}
    setDefaultConsent(oneTrustEnabled)
    initGTM({
      dataLayer: mergedState.dataLayer,
      dataLayerName: mergedState.dataLayerName,
      environment: mergedState.environment,
      nonce: mergedState.nonce,
      id: mergedState.id,
      serverName: mergedState.serverName
    })
    initOneTrust(oneTrustEnabled, oneTrustId)
  }, [state, oneTrustCheckCompleted])
  return (
    <GTMContext.Provider value={store}>
      <GTMContextDispatch.Provider value={dispatch}>
        <OneTrustCheckCompletedContext.Provider value={oneTrustCheckCompleted}>
          {children}
        </OneTrustCheckCompletedContext.Provider>
      </GTMContextDispatch.Provider>
    </GTMContext.Provider>
  )
}
function useGTMDispatch() {
  return useContext(GTMContextDispatch)
}

function useOneTrustCheckCompleted() {
  return useContext(OneTrustCheckCompletedContext)
}
export {GTMProvider, useGTMDispatch, sendToGTM, useOneTrustCheckCompleted}